import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-black/5 bg-white/40">
      <div className="pbp-section py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-6 h-6 rounded-md bg-[#1d1d1f] grid place-items-center text-white text-[10px] font-bold">
              Pp
            </div>
            <span className="font-semibold">PartByPart</span>
          </div>
          <p className="text-[#86868b] leading-relaxed">
            Made in India. Built for the world. Reduce e-waste, one Apple part at a time.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Explore</h4>
          <ul className="space-y-2 text-[#1d1d1f]">
            <li><Link className="pbp-link" to="/browse">Browse listings</Link></li>
            <li><Link className="pbp-link" to="/sell">List a part</Link></li>
            <li><Link className="pbp-link" to="/how-it-works">How it works</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Legal</h4>
          <ul className="space-y-2 text-[#1d1d1f]">
            <li><Link className="pbp-link" to="/terms">Terms &amp; Conditions</Link></li>
            <li><Link className="pbp-link" to="/privacy">Privacy Policy</Link></li>
            <li><Link className="pbp-link" to="/safety">Safety Guidelines</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3">Disclaimer</h4>
          <p className="text-[#86868b] text-[12.5px] leading-relaxed">
            PartByPart is a peer-to-peer marketplace. We do not verify users or guarantee
            authenticity. Always verify the seller&rsquo;s identity, inspect the product before
            payment, and meet in a safe public place. PartByPart is not affiliated with Apple Inc.
          </p>
        </div>
      </div>
      <div className="pbp-section py-5 text-xs text-[#86868b] flex flex-col sm:flex-row gap-2 sm:gap-6 justify-between border-t border-black/5">
        <span>&copy; {new Date().getFullYear()} PartByPart. All trademarks belong to their respective owners.</span>
        <span>Compliant with Information Technology Act, 2000 &amp; DPDP Act, 2023 (India).</span>
      </div>
    </footer>
  );
}
